import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { GlobalState } from 'ha/types/store';

import { STATE_NAME } from '../constants';
import { State as EntityState, entityReducer as entity } from './entityReducer';
import {
  State as UserInfoState,
  userInfoReducer as userInfo,
} from './userInfoReducer';
import {
  State as LoadStateState,
  loadStateReducer as loadState,
} from './loadStateReducer';
import {
  State as ListingsState,
  listingsReducer as listings,
} from './listingsReducer';
import {
  State as TenantReviewsState,
  tenantReviewsReducer as tenantReviews,
} from './tenantReviewsReducer';

export interface RootState extends GlobalState {
  [STATE_NAME]: {
    entity: EntityState;
    userInfo: UserInfoState;
    loadState: LoadStateState;
    listings: ListingsState;
    tenantReviews: TenantReviewsState;
  };
}

const reducer = combineReducers({
  entity,
  userInfo,
  loadState,
  listings,
  tenantReviews,
});

export { reducer };

const getUserPageState = (state: RootState) => state[STATE_NAME];

// entitySelectors
export const getUser = createSelector(
  getUserPageState,
  userPageState => userPageState?.entity,
);

// userInfoSelectors
export const getUserInfo = createSelector(
  getUserPageState,
  userPageState => userPageState?.userInfo,
);

// loadStateSelectors
export const getLoadState = createSelector(
  getUserPageState,
  userPageState => userPageState?.loadState,
);
export const getIsLoading = createSelector(
  getLoadState,
  loadStateState => loadStateState?.loading,
);
export const getErrors = createSelector(
  getLoadState,
  loadStateState => loadStateState?.errors,
);
export const getIsNotFound = createSelector(
  getLoadState,
  loadStateState => loadStateState?.isNotFound,
);

// listingsStateSelectors
export const getListingsState = createSelector(
  getUserPageState,
  userPageState => userPageState?.listings,
);

export const getGroupedListings = createSelector(
  getListingsState,
  listingsState => listingsState?.groupedListings,
);

// tenantReviewsSelectors
export const getTenantReviewsState = createSelector(
  getUserPageState,
  userPageState => userPageState?.tenantReviews,
);
export const getTenantReviewsReports = createSelector(
  getTenantReviewsState,
  tenantReviewsState => tenantReviewsState?.reports,
);
export const getTenantReviewsOverallRating = createSelector(
  getTenantReviewsState,
  tenantReviewsState => tenantReviewsState?.overallRating,
);
